<div class="row">
  <div class="column">
    <app-rental-property-info [property]="rentalProperty"></app-rental-property-info>
  </div>
  <div class="column">
    <form [formGroup]="additionalInfoForm">
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Name on the business sign</mat-label>
          <input formControlName="businessSign" matInput required>
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Website url</mat-label>
          <input formControlName="webSiteUrl" matInput>
        </mat-form-field>
      </div>
    </form>
  </div>
</div>
